/* Posity — laadstaat op de "Veilig afrekenen"-knop (winkelwagen en cart-drawer).

   Wat het doet: bij een klik gaat er een spinner in de plaats van de tekst en wordt
   een tweede klik geweigerd zolang de eerste loopt. De spinner blijft draaien tot de
   checkout in beeld komt — dit is een navigatie, geen fetch, dus er is geen
   "klaar"-moment om op te wachten.

   WAAROM DIT EEN APART BESTAND IS EN GEEN UITBREIDING VAN posity-atc-loading.js:
   dat bestand hangt aan #posity-pdp-add en stopt meteen als die knop er niet is. De
   checkout-knop zit in cart-summary.liquid, die op ELKE pagina meekomt via de
   cart-drawer. Andere levensduur, ander faalgedrag, andere valkuilen.

   VIER VALKUILEN DIE DE VORM VAN DIT BESTAND BEPALEN:

   1. Deze knop mag NIET op disabled. Hij draagt name="checkout", en juist die naam
      vertelt Shopify dat het om afrekenen gaat en niet om het bijwerken van de
      winkelwagen. Een disabled control valt uit de formulierdata, dus je zou naar
      /cart posten en terugkomen op je eigen winkelwagen. Dat is het verschil met de
      PDP-knop, die wel op slot mag. Het blokkeren van dubbele submits hangt hier
      volledig aan de inFlight-vlag hieronder.

   2. Terugkomen uit de checkout laat de spinner draaien. De browser haalt de
      winkelwagen dan uit bfcache, inclusief onze klasse en onze vlag — de klant kijkt
      naar een knop die eeuwig tolt en niet meer reageert. Vandaar de pageshow-listener
      met event.persisted.

   3. Listeners horen niet aan de knop. Horizon rendert de cart-drawer opnieuw bij elke
      cart:update, dus een listener op het element zelf is weg zodra iemand een aantal
      wijzigt. Daarom delegation op document, en de knop pas opzoeken op het moment dat
      we hem nodig hebben.

   4. Alleen checkout-submits afvangen. Hetzelfde formulier draagt ook de
      bijwerken-knop; die moet gewoon door kunnen. We kijken naar event.submitter.

   Blijft de navigatie helemaal uit (netwerk weg, checkout onbereikbaar), dan zou de
   knop zonder vangnet vast blijven staan. Vandaar de time-out. */
(function () {
  'use strict';

  var LOADING_CLASS = 'is-checkout-loading';
  /* Ruim boven een trage checkout-redirect op mobiel data, kort genoeg dat een klant
     niet naar een dode knop zit te kijken als de navigatie nooit begint. */
  var SAFETY_TIMEOUT = 15000;

  var inFlight = false;
  var timer = null;

  function buttons() {
    return document.querySelectorAll('.cart__checkout-button');
  }

  function isCheckoutSubmit(event) {
    var submitter = event.submitter;
    if (!submitter) return false;
    /* Zowel de naam als de klasse: de naam is wat Shopify leest, de klasse is wat wij
       stylen. Wijkt er ooit een van af, dan valt de laadstaat weg in plaats van dat we
       hem op de verkeerde knop zetten. */
    return submitter.name === 'checkout' && submitter.classList.contains('cart__checkout-button');
  }

  function applyLoading() {
    Array.prototype.forEach.call(buttons(), function (btn) {
      btn.classList.add(LOADING_CLASS);
      btn.setAttribute('aria-busy', 'true');
    });
  }

  function reset() {
    inFlight = false;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    Array.prototype.forEach.call(buttons(), function (btn) {
      btn.classList.remove(LOADING_CLASS);
      btn.removeAttribute('aria-busy');
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      if (!isCheckoutSubmit(event)) return;

      if (inFlight) {
        /* Tweede klik terwijl de eerste navigatie loopt: hier stopt hij.
           stopImmediatePropagation houdt ook Horizons eigen listeners tegen. */
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      inFlight = true;
      applyLoading();
      timer = setTimeout(reset, SAFETY_TIMEOUT);
    },
    true
  );

  /* Zie valkuil 2: terug uit de checkout geeft een pagina uit bfcache, met spinner. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) reset();
  });

  /* De drawer herrendert bij een wijziging in de winkelwagen. De knop is dan nieuw en
     dus schoon, maar onze vlag niet — zonder deze reset zou de volgende echte klik
     geweigerd worden. */
  document.addEventListener('cart:update', function () {
    if (inFlight) reset();
  });
})();
